// extracted by mini-css-extract-plugin
module.exports = {"container":"_dn","content":"_do","image":"_dp","text":"_dq","form":"_dr","button":"_ds"};